/**
 * Round-trip Requests-list filter state to the browser URL so the view is
 * shareable. We use the current URL's search string and only touch keys we
 * own, so other features sharing the same URL aren't disturbed.
 */

const PREFIX = "r_";

const KEYS = [
  "status_in",
  "severity",
  "service",
  "account",
  "check",
  "search",
  "sort",
  "page_size",
  "next_token",
  "created_from",
  "created_to",
];

export const readFiltersFromUrl = () => {
  if (typeof window === "undefined") return {};
  const params = new URLSearchParams(window.location.search);
  const out = {};
  for (const k of KEYS) {
    const v = params.get(PREFIX + k);
    if (v) out[k] = v;
  }
  return out;
};

export const writeFiltersToUrl = (filters) => {
  if (typeof window === "undefined") return;
  try {
    const params = new URLSearchParams(window.location.search);
    for (const k of KEYS) params.delete(PREFIX + k);
    for (const [k, v] of Object.entries(filters || {})) {
      if (v == null || v === "" || (Array.isArray(v) && v.length === 0)) continue;
      params.set(PREFIX + k, String(v));
    }
    const next = `${window.location.pathname}?${params.toString()}${window.location.hash}`;
    window.history.replaceState(null, "", next);
  } catch (_e) {
    /* no-op */
  }
};
